import React from "react";
import Modal from "react-bootstrap/Modal";
import BailingImage from "../../../../../../../../assets/images/bailing.png";
// import "./index.css";

const BailingSuccessfuldModal = ({
  showBailingSuccessful,
  handleCloseBailingSuccessful,
  weight,
  setWeight,
  category,
}) => {
  return (
    <div>
      <Modal
        show={showBailingSuccessful}
        onHide={() => {
          handleCloseBailingSuccessful();
          setWeight(null);
          window.location.reload();
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-left ml-3">
            <div className="mb-2">
              <div className="text-center mt-3 mb-5">
                <div className="successImg mb-4">
                  <img src={BailingImage} alt="success img" />
                </div>
                <div>
                  <h6>Bailing Successful</h6>
                  {/* Just what was bailed. The center's remaining balance used
                      to be printed beside it, which handed an operator the
                      figure to bail up against. */}
                  <p style={{ fontSize: "14px", marginTop: "10px" }}>
                    <span style={{ fontWeight: "bold", color: "#404040" }}>
                      Weight bailed:&nbsp;
                    </span>
                    <span style={{ fontWeight: "bold", color: "#84BD00" }}>
                      {`${Number(weight || 0).toLocaleString(undefined, {
                        maximumFractionDigits: 3,
                      })} kg`}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BailingSuccessfuldModal;
